var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.53333C2 3.87647 3.34315 2.53333 5 2.53333H8.27924C9.1401 2.53333 9.90438 3.08419 10.1766 3.90087L11.6744 8.39431C11.9892 9.33853 11.5617 10.3705 10.6715 10.8156L9.31494 11.4939C10.2016 13.0425 11.4908 14.3318 13.0394 15.2184L13.7177 13.8618C14.1628 12.9716 15.1948 12.5442 16.139 12.8589L20.6325 14.3567C21.4491 14.6289 22 15.3932 22 16.2541V19.5333C22 21.1902 20.6569 22.5333 19 22.5333H18C9.16344 22.5333 2 15.3699 2 6.53333V5.53333ZM5 4.53333C4.44772 4.53333 4 4.98104 4 5.53333V6.53333C4 14.2653 10.268 20.5333 18 20.5333H19C19.5523 20.5333 20 20.0856 20 19.5333V16.2541L15.5066 14.7563L14.3779 17.0135C14.1379 17.4936 13.5618 17.6985 13.0725 17.4779C10.4054 16.2755 8.25786 14.1279 7.05538 11.4608C6.83479 10.9716 7.03975 10.3954 7.51979 10.1554L9.77705 9.02676L8.27924 4.53333H5Z",
    fill: "#6A41A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.72980661be9dffac4347e24336c849f7.svg";
export { ForwardRef as ReactComponent };